


























































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import GoodSelect from '@/components/goods-select/index.vue'
import { ImageDrop } from 'quill-image-drop-module'
@Component({
  components: {
    GoodSelect,
  },
})
export default class IntervalSwiper extends Vue {
  selectRightItem: number = 0
  showGoodsIndex = -1
  prodcuts: any[] = []
  @Prop({
    type: Boolean,
    default: () => false,
  })
  showDemo!: boolean

  @Prop({
    type: Object,
    default: () => {
      return {
        type: 'intervalSwiper',
        items: [
          {
            title: null,
            maxNumber: 12,
            products: [],
            list: [],
          },
        ],
      }
    },
  })
  intervalSwiperConfig!: any

  @Prop({
    type: Number,
    default: 0,
  })
  selectRightNumber!: number

  @Prop()
  goodsList!: any

  mounted() {}

  // 选择右边组件
  selectRight(index) {
    console.log(index)
    this.selectRightItem = index
    this.$emit('handleSelectright', index)
    this.$emit('handleSelectGoods', this.getNewArray(this.intervalSwiperConfig.items[index].products, 6))
  }
  /**
   * 删除模块
   */
  deleteFn(index) {
    this.intervalSwiperConfig.items.splice(index, 1)
  }
  /**
   * 删除所选商品
   */
  deleteProduct(index, sonIndex) {
    this.intervalSwiperConfig.items[index].list.splice(sonIndex, 1)
    this.intervalSwiperConfig.items[index].products.splice(sonIndex, 1)
  }

  /**
   * 添加模块
   */
  addFn(index) {
    let obj = {
      title: null,
      maxNumber: 12,
      products: [],
      list: [],
    }
    this.intervalSwiperConfig.items.push(obj)
  }
  /**
   * 鼠标移入/移出事件
   */
  onMouseFn(index?) {
    this.showGoodsIndex = index
  }
  /**
   * 选择商品信息
   */
  productsChange(e, parentIndex) {
    if (e) {
      console.log(e, parentIndex)
      e.forEach((item, index) => {
        if (
          this.intervalSwiperConfig.items[parentIndex].list.indexOf(item.id) == -1 &&
          index < this.intervalSwiperConfig.items[parentIndex].maxNumber &&
          this.intervalSwiperConfig.items[parentIndex].list.length <
            this.intervalSwiperConfig.items[parentIndex].maxNumber
        ) {
          this.intervalSwiperConfig.items[parentIndex].list.push(item.id)
          this.intervalSwiperConfig.items[parentIndex].products.push(item)
        }
      })
      this.$emit('handleSelectGoods', this.getNewArray(this.intervalSwiperConfig.items[parentIndex].products, 6))
    }
  }
  getNewArray(array, subGroupLength) {
    let index = 0
    let newArray = []
    while (index < array.length) {
      newArray.push(array.slice(index, (index += subGroupLength)))
    }
    return newArray
  }
}
